export default "__VITE_ASSET__Dyu1qCSB__"